import { render } from "./FormSwitch.vue?vue&type=template&id=4fb57da1"
import script from "./FormSwitch.vue?vue&type=script&lang=js"
export * from "./FormSwitch.vue?vue&type=script&lang=js"
script.render = render

export default script